import { useEffect, useState } from 'react';
import { useRecoilState, useSetRecoilState } from 'recoil';
import styles from './style.module.css';
import useApi from '../../services/useApi';
import { newTaskConfig,namespaceState } from '../../recoil/atoms';
import { taskConfigDefault } from '../../constants';
import Cell from './Cell';
import NewTaskHeader from '../../compoenets/NewTaskHeader';
import containKeyword from '../../utils/containKeyword';
import CellSkeleton from './CellSkeleton';

// const APP_LIST=[{
//     packageName:"com.sec.android.app.message",
//     appName:"message",
//     minVersionList:["none","0.0.1","0.0.2","0.0.3"],
//     dataType:["text","image"],
// }]

export default function NewTaskApp(){
    const [nsState,]=useRecoilState(namespaceState);
    const setTaskConfig = useSetRecoilState(newTaskConfig);
    const [appList,setAppList]=useState(null);
    const [serachValue,setSearchValue]=useState("");

    useEffect(()=>{
        setTaskConfig(taskConfigDefault);
        useApi.get('ngp/dm/device/app?namespaceId='+nsState.id).then(res=>{
            setAppList(res.data)
        })
    },[])

    return(
        <div className={styles['wrap']}>
            <NewTaskHeader/>
            <div className={styles['body']}>
                <header>
                    <span>학습 데이터로 사용될 애플리케이션을 선택하세요.</span>
                    <div className={styles['search']}>
                        <input 
                        placeholder='Search application or data'
                        value={serachValue}
                        onChange={(e)=>setSearchValue(e.target.value)}
                        ></input>
                        {serachValue!==""&&<button onClick={()=>setSearchValue("")}/>}
                    </div>
                </header>
                <main>
                    {appList?
                    appList?.map((item)=>
                        (containKeyword(item.appName,serachValue)&&<Cell key={item.packageName} {...item}></Cell>)
                    ):
                    <>
                    <CellSkeleton/>
                    <CellSkeleton/>
                    <CellSkeleton/>
                    <CellSkeleton/>
                    <CellSkeleton/>
                    <CellSkeleton/>
                    </>}
                </main>
            </div>
        </div>
    )
}